function getCellClassName(data, className) {
    if (!className) {
        return;
    }

    return typeof(className) === 'function'
        ? className(data)
        : className;
}

function getCellExtraProps(data, formatExtraProps) {
    return typeof(formatExtraProps) === 'function'
        ? formatExtraProps(data)
        : formatExtraProps;
}

export default {
    getCellClassName,
    getCellExtraProps
};
